import React, {PureComponent} from "react"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import Spacing from "@irati/ui/src/Spacing"

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  background-color: #999;
  color: white;
  padding: 2px;
  padding-left: 10px;
`

interface Props {
  text: string,
  value: string,
  onClear: () => void
}

export default class VersionRow extends PureComponent<Props> {
  render() {
    const {text, value, onClear} = this.props

    return (
      <Wrapper>
        <Spacing padding={[0, 1]}>
          {text} = {value}
        </Spacing>
        |
        <Spacing padding={[0, 1]}>
          <Button tertiary inverted onClick={onClear}>Clear</Button>
        </Spacing>
      </Wrapper>
    )
  }
}
